<template><section><h3>{{title}}</h3><slot /></section></template><script setup lang="ts">defineProps<{title:string}>();</script><style scoped>section{margin-top:22px}h3{margin:0 0 10px;color:#344054;font-size:15px}</style>
